import { RefundStatus } from '../booking/booking'

export enum PaymentStatus {
  FAILED = 'FAILED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  /** Card authorised, not captured yet. */
  AUTHORIZED = 'AUTHORIZED',
  SUCCESS = 'SUCCESS',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED',
}

export enum PaymentMethod {
  CARD = 'CARD',
  CASH = 'CASH',
  BANK_TRANSFER = 'BANK_TRANSFER',
}

export enum PaymentReferenceType {
  CHECKOUT = 'CHECKOUT',
}

export type PaymentFilterType = PaymentMethod | 'ALL'

export const PAYMENT_FILTERS: PaymentFilterType[] = [
  'ALL',
  ...Object.values(PaymentMethod),
]

export type PaymentMetadata = {
  id: string
  owner?: string
  createdDate: string
  amount: number
  currency: string
  status: PaymentStatus
  paymentMethod?: PaymentMethod
  type?: PaymentReferenceType
  /** Checkout id. */
  referenceId?: string
  refundStatus?: RefundStatus
  /** Refund points spent in the same checkout, on top of the amount. */
  pointsAmount?: number
}
